module.exports = __webpack_public_path__ + "img/attack of the giants.8168afb8.png";